import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { PAYMENT_METHODS_LIST_MUTATION } from "../../graphql/mutations";
import { useMutation } from "@apollo/client";

import { Loading } from "components/Loading";

import PaymentMethodForm from "./PaymentMethodForm";

import { Result } from "antd";

const PaymentMethod = () => {
  const location = useLocation();

  const { t } = useTranslation();

  const [paymentMethodsList, setPaymentMethodsList] = useState([]);
  const [paymentMethodsListLoading, setPaymentMethodsListLoading] = useState(true);

  const [total, setTotal] = useState(null);

  const [errorMessage, setErrorMessage] = useState(null);

  const [fetchPaymentMethodsList] = useMutation(PAYMENT_METHODS_LIST_MUTATION);

  useEffect(() => {
    const fetchData = async () => {
      const checkoutPage = location.pathname === "/checkout";

      if (checkoutPage) setTotal(getTotalPrice());

      const { data } = await fetchPaymentMethodsList({
        variables: checkoutPage ? { total: getTotalPrice() } : {},
      });

      if (!data.paymentMethodsList.success) setErrorMessage(data.paymentMethodsList.errors[0]);
      else {
        const paymentMethodsData = data.paymentMethodsList.paymentMethods;
        setPaymentMethodsList(paymentMethodsData.map((obj) => JSON.parse(obj)));
      }

      setPaymentMethodsListLoading(false);
    };

    fetchData();
  }, []);

  if (paymentMethodsListLoading) return <Loading />;

  if (errorMessage)
    return (
      <Result
        status="error"
        title={t("payment.paymentMethodForm.errorMessageTitle")}
        subTitle={
          <span dir="ltr" className="english-field">
            {errorMessage}
          </span>
        }
      />
    );

  return <PaymentMethodForm {...{ paymentMethodsList, total }} />;
};

export default PaymentMethod;

const getTotalPrice = () => {
  const savedCart = localStorage.getItem("cart");
  if (savedCart) {
    const cartItems = JSON.parse(savedCart);
    return cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }
  return 0; // Return 0 if the cart is empty or doesn't exist
};
